'use strict';

exports.mirror = function (namespace, obj) {

    return Object.keys(obj).reduce(function (collector, key) {

        collector[key] = namespace + '/' + key;
        return collector;
    }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/strange-auth/lib/utils.js
// module id = 598
// module chunks = 0